/* esm.sh - @radix-ui/react-checkbox@1.3.3 */
export * from "/*@radix-ui/react-checkbox@1.3.3/esnext/react-checkbox.mjs";
